import React, { useState } from 'react';
import ProductCategoryDetailsFields from './ProductCategoryDetailsFields';

function EditProductCategory({ CategoryData, sendDataToParent }) {
  const [slugManual, setSlugManual] = useState(true);

  const handleData = (data) => {
    if (sendDataToParent) sendDataToParent(data);
  };

  return (
    <div className="card-body px-0">
      <ProductCategoryDetailsFields
        formData={CategoryData}
        sendDataToParent={handleData}
        slugManual={slugManual}
        onSlugManualChange={setSlugManual}
      />
    </div>
  );
}

export default EditProductCategory;
